import React, { memo, useMemo } from "react";
import { Blok } from "../../interfaces/Blok.interface";
import StructuredData from "../StructuredData/StructuredData";

interface ContactPointStructuredDataBlokProps extends Blok {
  contactType: string;
  contactAddress: string;
}

interface ContactPointStructuredDataProps {
  blok: ContactPointStructuredDataBlokProps;
}

const ContactPointStructuredData: React.FC<ContactPointStructuredDataProps> = ({
  blok
}) => {
  const contactPointStructuredData = useMemo(() => {
    const contactAddress: string = blok.contactAddress;
    const contactType: string = blok.contactType.toLowerCase();
    const isEmail: boolean = /^\S+@\S+\.\S+$/.test(blok.contactAddress);
    const contactPoint: Record<string, string> = {
      "@type": "ContactPoint",
      contactType: contactType
    };
    if (isEmail) {
      contactPoint["email"] = contactAddress;
    } else {
      contactPoint["telephone"] = contactAddress;
    }

    return {
      "@type": "Organization",
      contactPoint: [contactPoint]
    };
  }, [blok]);

  return <StructuredData>{contactPointStructuredData}</StructuredData>;
};

export default memo(ContactPointStructuredData);
